import { detectors } from '@/app/constants';
import type { ImageType } from '@/app/types';

export function detectImageTypeByBuffer(buffer: ArrayBuffer): ImageType | null {
  const uint8Array = new Uint8Array(buffer);

  for (const detector of detectors) {
    if (detector.check(uint8Array)) {
      return detector.type;
    }
  }

  return null;
}
